import { render, staticRenderFns } from "./CustomerReceive.vue?vue&type=template&id=b25b9682"
import script from "./CustomerReceive.vue?vue&type=script&lang=js"
export * from "./CustomerReceive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports